/*@flow*/
import qs from 'qs';
import getBbox from 'lib/getBbox';
import { state } from 'ops';
import type { UrlProps } from './types';

export default ({
  panelName,
  id,
  showDrawingTool,
  showBoundary,
  dataPanels,
  resourceName,
  showShapes,
  showImagesInListView,
  toolbarButtons,
}: UrlProps): string => {
  let queryString = qs.stringify(
    state('$query')
      .setIn(['load', 'dashboardId'], id)
      .setIn(['load', 'bbox'], getBbox())
      .setIn(['load', 'showDrawingTool'], showDrawingTool)
      .setIn(['load', 'showBoundary'], showBoundary)
      .setIn(['load', 'dataPanels'], dataPanels)
      .setIn(['load', 'panelName'], panelName)
      .setIn(['load', 'showShapes'], showShapes)
      .setIn(['load', 'showImagesInListView'], showImagesInListView)
      .setIn(['load', 'toolbarButtons'], toolbarButtons)
      .toJS()
  );

  let base = `https://${window.location.host}`;
  let url = `${base}/${resourceName}/${id}/embed?${queryString}`;
  return url;
};
